import { forwardRef } from 'react';

import { Box } from '../../Box/Box';

import * as styles from './styles.css';

export type Props = React.PropsWithChildren & styles.Variants;

export const Truncate = forwardRef<unknown, Props>(({ children, lines }, ref) => (
  <Box as="span" ref={ref} cssClass={styles.variants({ lines })}>
    {children}
  </Box>
));

Truncate.displayName = 'Truncate';
